const THEMES_CANNABIS = [
  "Creativity",
  "Relaxation",
  "Introspection",
  "Clarity",
  "Grounding",
  "Presence",
  "Release",
  "Healing",
  "Focus",
  "Sensory",
  "Connection",
  "Play",
  "Rest",
  "Renewal",
  "Expansion",
];

const THEMES_MUSHROOM = [
  "Death & Rebirth",
  "Ego Dissolution",
  "Shadow",
  "Integration",
  "Surrender",
  "Expansion",
  "Ancestral",
  "Inner Child",
  "Grief",
  "Love",
  "Oneness",
  "Void",
  "Awakening",
  "Healing",
  "Transformation",
  "Renewal",
  "Presence",
  "Gratitude",
  "Fear",
  "Forgiveness"
];

function ArchetypalThemes({ value, onChange, isMushroom }) {
  const THEMES = isMushroom ? THEMES_MUSHROOM : THEMES_CANNABIS;
  const selected = value ? value.split(",").map(t => t.trim()).filter(Boolean) : [];

  const toggleTheme = (theme) => {
    if (selected.includes(theme)) {
      onChange(selected.filter(t => t !== theme).join(", "));
    } else {
      onChange([...selected, theme].join(", "));
    }
  };

  return (
    <div className="ArchetypalThemes">
      <p style={{ fontSize: "13px", opacity: 0.6, marginBottom: "12px" }}>
        Select any themes that feel present or active in this part of the session, emotional, mental, sensory, or energetic patterns you notice.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {THEMES.map(theme => {
          const isMushroomOnly = isMushroom && !THEMES_CANNABIS.includes(theme);
          const isSelected = selected.includes(theme);
          return (
            <span
              key={theme}
              onClick={() => toggleTheme(theme)}
              style={{
                cursor: "pointer",
                padding: "6px 14px",
                borderRadius: "20px",
                fontSize: "13px",
                border: isSelected
                  ? "1px solid rgba(125, 211, 232, 0.8)"
                  : isMushroomOnly
                    ? "1px solid rgba(210, 175, 255, 0.4)"
                    : "1px solid rgba(255,255,255,0.2)",
                background: isSelected
                  ? "rgba(125, 211, 232, 0.15)"
                  : isMushroomOnly
                    ? "rgba(210, 175, 255, 0.08)"
                    : "rgba(255,255,255,0.05)",
                color: isSelected
                  ? "#7dd3e8"
                  : isMushroomOnly
                    ? "#d4b0ff"
                    : "inherit",
                transition: "all 0.2s"
              }}
            >
              {theme}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default ArchetypalThemes;